/**
 * @file Constants
 * @description Hold Alberta.js constants files
 */
const constant = {
  /**
   * Use for default attribute data for SRCi mark
   */
  IMAGE_ALT_TEXT: 'Alberta Image Text',
  IMAGE_DEFAULT_URL: 'https://masterpass.com/dyn/img/btn/global/mp_chk_btn_326x076px.svg',
  IMAGE_DEFAULT_SIZE: 512,
  CLIENT_ID: 111111,
  EVENTS: {
    READY: 'SRCI_READY',
    DCF_READY: 'READY',
    UPDATE: 'UPDATE',
    CANCEL: 'CANCEL',
    LAUNCH_DCF: 'LAUNCH_DCF',
    DCF_ACTION: 'ACTION',
    SRCI_STATE_REQUEST: 'SRCI_STATE_REQUEST',
    SRCI_REQUEST: 'SRCI_REQUEST',
    GET_NORMALIZED_MERCHANT_DATA: 'GET_NORMALIZED_MERCHANT_DATA',
    GET_CORRELATION_ID: 'GET_CORRELATION_ID',
    DID_HANDLE_ENROLLMENT_ERROR: 'DID_HANDLE_ENROLLMENT_ERROR'
  },
  ACTIONS: {
    INIT: 'INIT', // Cannot be received from DCF
    SWITCH_CONSUMER: 'SWITCH_CONSUMER',
    CHANGE_CARD: 'CHANGE_CARD',
    AUTH_SKIPPED: 'AUTH_SKIPPED',
    AUTH_FAILED: 'AUTH_FAILED',
    COMPLETE: 'COMPLETE',
    CANCEL: 'CANCEL',
    ERROR: 'ERROR'
  },
  KEY: {
    ALLOWED_CARD_TYPES: 'allowedCardTypes',
    AMOUNT: 'amount',
    CHECKOUT_ID: 'checkoutId',
    CALLBACK_URL: 'callbackUrl',
    CART_ID: 'cartId',
    CRYPTO_OPTIONS: 'cryptoOptions',
    CURRENCY: 'currency',
    CVC2_SUPPORT: 'cvc2Support',
    DISPLAY_LANGUAGE: 'displayLanguage',
    SHIPPING_LOCATION_PROFILE: 'shippingLocationProfile',
    SUPPRESS_3DS: 'suppress3Ds',
    SUPPRESS_SHIPPING_ADDRESS: 'suppressShippingAddress',
    UNPREDICTABLE_NUMBER: 'unpredictableNumber',
    USER_ID: 'userId',
    VALIDITY_PERIOD_MINUTES: 'validityPeriodMinutes'
  },
  TYPE: {
    ARRAY: 'Array',
    BOOLEAN: 'Boolean',
    NUMBER: 'Number',
    OBJECT: 'Object',
    STRING: 'String',
    URL: 'Url'
  },
  SDKS: {
    'mastercard': {
      URL: process.env.MASTERCARD_SDK_URL || '',
      INITIATOR_ID: process.env.MASTERCARD_SRC_INITIATOR_ID || ''
    },
    'visa': {
      URL: process.env.VISA_SDK_URL || '',
      INITIATOR_ID: process.env.VISA_SRC_INITIATOR_ID || ''
    },
    'amex': {
      URL: process.env.AMEX_SDK_URL || '',
      INITIATOR_ID: process.env.AMEX_SRC_INITIATOR_ID || ''
    },
    'discover': {
      URL: process.env.DISCOVER_SDK_URL || '',
      INITIATOR_ID: process.env.DISCOVER_SRC_INITIATOR_ID || ''
    }
  },
  SAMPLE_RATES: {
    SMALL_SAMPLE_RATE: parseFloat(process.env.SRC_PERF_SMALL_SAMPLE_RATE) || 0.0001,
    MEDIUM_SAMPLE_RATE: parseFloat(process.env.SRC_PERF_MEDIUM_SAMPLE_RATE) || 0.01
  }
}

module.exports = constant
